import type { ActionButtonProps } from '@openx/components-header/HeaderActions/ActionButton';
import { HeaderActions } from '@openx/components-header/HeaderActions/HeaderActions';
import { PageHeader } from '@openx/components-header/PageHeader';
import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { useTaxonomyDownload } from '../utils/useTaxonomyDownload';

export const TaxonomyHeader = ({ children }): JSX.Element => {
  const { t } = useTranslation();

  const { taxonomyLoading, handleDownloading } = useTaxonomyDownload();
  const actions: Array<ActionButtonProps> = [
    {
      color: 'primary',
      'data-test': 'download-taxonomy-button',
      isAllowed: true,
      label: t('Download Taxonomy'),
      loading: taxonomyLoading,
      onClick: handleDownloading,
      showAsActionButton: true,
    },
  ];

  return (
    <PageHeader
      titlePrefix="OpenXSelect"
      title={t('OpenXSelect Taxonomy')}
      render={() => <HeaderActions actions={actions} />}
      sticky
    >
      {children}
    </PageHeader>
  );
};
